export const ErrorReason = {
  UNHANDLED: "und",
  ATTENDEE_ALREADY_JOINED: "rjn",
  CONFERENCE_ENDED: "cfe",
} as const

export type ErrorReasonKeys = keyof typeof ErrorReason
export type ErrorReasonValues = typeof ErrorReason[ErrorReasonKeys]
